export const categories = [
  {
    slug: 'tutorials',
    name: '使用教程',
    description: '从零开始学习磁力链的完整使用教程，涵盖基础概念、下载流程、格式转换等核心知识。',
    icon: 'ri-book-open-line',
    articleCount: 4,
  },
  {
    slug: 'clients',
    name: '客户端推荐',
    description: '精选主流磁力链下载客户端，提供详细评测、配置教程与优化建议，助你选择最佳工具。',
    icon: 'ri-computer-line',
    articleCount: 4,
  },
  {
    slug: 'search-tips',
    name: '搜索技巧',
    description: '掌握高效搜索磁力链资源的方法与技巧，了解主流搜索引擎及高级搜索策略。',
    icon: 'ri-search-line',
    articleCount: 4,
  },
  {
    slug: 'faq-category',
    name: '常见问题',
    description: '汇总磁力链使用过程中的常见疑问与解决方案，涵盖速度优化、兼容性、安全性等问题。',
    icon: 'ri-question-line',
    articleCount: 4,
  },
  {
    slug: 'resources',
    name: '资源导航',
    description: '整理优质磁力链资源站点、DHT网络节点、Tracker服务器列表及磁力链社区推荐。',
    icon: 'ri-compass-3-line',
    articleCount: 3,
  },
];